// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"192231aa","453":"7435e3a2","667":"e308edec","977":"a6d38159"}[chunkId] + ".chunk.js";
};